/* eslint-disable */
/*
Purpose: displays images for a user, if specified, or images for all the current user follows. toggle grid vs list mode

Notes:
Like other RecyclingScrollView pages, the main data is loaded directly via fetch.
Keep in mind that there could be other copies of this screen in the navigation stack.
When in list (as opposed to grid) mode, there needs to be an api call to load the full Post details (10 at a time max)
This might best be accomplished with Sagas.
Note the visibility property, this need to be more sophisticated as we want all copies of this screen
on the navigationstack to show just pastel squares aside from the one that is on top.
This is to try and reduce the amount of memory used, and reduce the likelyhood of a crash.

Started work on making this a bit more generic, as it can be used in other places.
Overriding header and other functions will allow this code to work elsewhere.
*/

import React, { Component } from "react"
import {
  Image,
  TouchableOpacity,
  View,
  Text,
  FlatList,
  ActivityIndicator,
  Dimensions,
  RefreshControl,
  Platform
} from "react-native"

import { KargoeConfig } from '../Config/AppConfig'

import { connect } from "react-redux"
import { NavigationActions } from 'react-navigation';

import PostsActions from "../Redux/PostsRedux"
import PostDetailsActions from "../Redux/PostDetails2Redux"
import LoveActions from "../Redux/LoveRedux"
import CreatePostActions from "../Redux/CreatePostRedux"
import OrderActions from "../Redux/OrderRedux"
import UserActions from "../Redux/UserRedux"
import SwiperActions from '../Redux/SwiperRedux'
import PaypalActions from '../Redux/PaypalRedux'
import ActionSheetActions from '../Redux/ActionSheetRedux'
import MessagesActions from '../Redux/MessagesRedux'
import CouponActions from '../Redux/CouponRedux'
import KargoeTagActions from '../Redux/KargoeTagRedux'
import FollowActions from '../Redux/FollowRedux'
import AuthActions from "../Redux/AuthRedux"

import CustomMainNavBar from '../Components/CustomMainNavBar'
//import { captureScreen } from "react-native-view-shot"
import NotificationManager from '../Lib/NotificationManager'
import {alertView, parseQRCode} from '../Lib/utils'
import I18n from "i18n-js"

// Styles
import styles from "./Styles/PostWallScreenStyle"
import Colors from "../Themes/Colors"
import Images from "../Themes/Images"

import PostWallBase from './PostWallBase'

const LIST_MODE = 'list'

// NOTE: override renderHeader or other parts to use as you wish

class PostWallV2Screen extends PostWallBase {

  static screenCaptured = false // move to static so it only happens once per run session

  constructor(args) {
    const newArgs = Object.assign({}, args, {
      initialMode: LIST_MODE,
    })
    super(newArgs)
    console.tron.display({
      name: `PostWallV2Screen`,
      preview :``,
      value: {
        newArgs: newArgs
      }
    })

    this.HomeWall = true
    this.ProfileWall = false

  }

  resetRoute = (routeName) => this.props.navigation.navigate(routeName, {})

	// componentDidUpdate(prevProps, prevState) {
	componentWillReceiveProps(nextProps) {
		super.componentWillReceiveProps(nextProps)
  }

  componentWillMount ( ) {
    super.componentWillMount( )

    // catch after we goBack to this home wall
    // https://github.com/react-navigation/react-navigation/issues/684
    // see note from Sep 16 2018 in the above link

    this.didFocusSubscription = this.props.navigation.addListener(
    'didFocus',
    payload => { console.log('post wall v2 screen didFocus', payload);
                 // force re-render the bottom overlay which has the avatar in it,
                 // in case the avatar has changed
                 this.setState({overlayPostViewKey : this.state.overlayPostViewKey + 1})
                 this.focused = true // defined in superclass post wall basd, kind of weird, maybe should
                 // put the blur handler here too
               }
    )

  }
  componentWillUnmount ( ) {
    super.componentWillUnmount( )

    this.didFocusSubscription.remove()
  }
  // getUnreadMessage=()=>{
  //   this.props.getUnreadMessage()
  // }
  // componentDidMount() {
  //   this.getUnreadMessage( )
  // }
  // componentDidUpdate(prevProps, prevState) {
  //   console.log(this.props.unreadMessages)
  // }
  loadMoreDataUrl() {
    // seed is used to force an update and get new stuff, in this example...
    // const url = `https://randomuser.me/api/?seed=${seed}&page=${page}&results=20`;
    const length = 100
    const userId = this.state.userId ? this.state.userId : ""
    const start = this.state.start && !this.state.refreshing ? this.state.start : ""
    const url = `${KargoeConfig.baseUrlAPI}v1/post?UserId=${userId}&limit=${length}&start=${start}&miniHints=true`
    console.tron.log(`loadMoreDataUrl: ${url}`)

    // http://facebook.github.io/react-native/releases/0.49/docs/network.html#using-fetch
    const options = {
      method: "GET",
      headers: {
        Authorization: "Token " + this.props.auth.token
        // 'Accept': 'application/json',
        // 'Content-Type': 'application/json',
      }
    }
    return {
      url: url,
      options: options,
    }
  }

  loadMoreVidDataUrl ( ) {
    const userId = this.state.userId? this.state.userId: ''
    const start = (this.state.vidStart && !this.state.refreshing)? this.state.start: ''
    const url = `${KargoeConfig.baseUrlAPI}v1/post?UserId=${userId}&limit=100&start=${start}&videos=true`
    const options = {
      method: 'GET',
      headers: { Authorization: `Token ${this.props.auth.token}` }
    }
    return {
      url: url,
      options: options
    }
  }

  componentDidMount ( ) {
    super.componentDidMount ( )
    // this way, state.user is established globally by the root of the program
    this.props.readUser( this.props.auth.user.UserId )
    this.props.readSelf(this.props.auth.user.UserId)
  }

  snapScreen( ) {

    return
    
    //if (!this.gridScrollView || !this.gridScrollView.contentOffset) return // nothing to snap

    //if (this.gridScrollView.contentOffset.y !== 0) return // wrong scroll position, dont snap

    captureScreen({
      format: "jpg",
      quality: 0.8
    })
    .then(
      uri => {//console.log("post view image saved to ", uri)
              // note:  on ios this is a file path not a uri, the documentation seems to be wrong
              // send this path to Obj-C for later use, see AppDelegate.m
              NotificationManager.postNotificationWithString("PostWallV2Screen_screenshotUri", uri)
            },
      error => console.log("Oops, snapshot failed in post wall v2 screen")
    )
  }
  renderHeader(makeTransparentHeader, progress) {
    //console.log("render header of post wall v2 screen")
    if (!PostWallV2Screen.screenCaptured) {
        setTimeout(this.snapScreen, 2500); // test worked ok
        PostWallV2Screen.screenCaptured = true
    }
    const title = this.state.currVideoPlayIndex >= 0 ? `Kargoe vid ${this.state.currVideoPlayIndex}` : `kargoe`
    const transparent = this.props.transparentPanels // makeTransparentHeader
    const isWeb = Platform.OS == 'web'
    return (
      <CustomMainNavBar
        isHomeScreen={true}
        transparent={transparent}
        leftButtonTitle={this.state.viewMode}
        onLeftPress={this.clickMode}
        rightButtonTitle={'happening'}
        onRightPress={(x) => {if (!isWeb) this.onHappeningPress(x)}}
        rightButtonInnerTitle={'barcode'}
        onRightInnerPress={(x) => {if (!isWeb) this.onBarcodePress(x)}}
        title={``} // ``, `Home Wall V2`
        online={null}
        onTitlePress={this.onTitlePress}
        unreadHappening={this.props.auth.user && this.props.auth.user.LastActivityUpdate}
      />
    )
  }
  onHappeningPress = ( ) => {
    // this.props.navigation.navigate('explora', { })
    this.resetRoute('happening')
  }
  onBarcodePress = ( ) => {
    console.log("onBarcodePress")
    this.props.navigation.navigate('barCoder', { getBarcoder : this.getBarcoder })
  }
  // QR, bar, whatever the tricorder supports
  getBarcoder = ({barcoder}) => {
    if (this.props.nav.routes.length != 1) {
      console.tron.log(`barcoder output: ${barcoder} PostWallV2Screen is not the only screen, ignoring`)
      return
    }
    console.tron.log(`barcoder output: ${barcoder}`)
    console.log("qrcode = " + barcoder)
    const qrCodeDetails = parseQRCode(barcoder)
    if (qrCodeDetails.OfferId)
      this.props.getOffer(qrCodeDetails.OfferId, null)
    else if (qrCodeDetails.VendorId)
      this.props.getVendor(qrCodeDetails.VendorId)
    else {
      var isANumber = isNaN(barcoder) === false;
      if (!isANumber) {
        alertView(I18n.t("editpost.invalidScan"), I18n.t("editpost.invalidScanMsg"))
        return
      }
      console.tron.log(`scanned barcode '${barcoder}' was not a kargoe offer or vendor, maybe an item`)
      // this.setErrorMessage("This is not a Kargoe QR Code") // alertView("👎",
      console.log("should search item " + qrCodeDetails.ItemId) // working
      //this.props.searchItems({ search: qrCodeDetails.ItemId, filter: "CODE_LOOKUP", limit: 1 })

      this.props.navigation.navigate('explora', { barcoderResult : qrCodeDetails.ItemId })

      setTimeout(function() {
        this.props.changeIndex({ indexChange: 1 }) // back to app side, not barcode side
      }.bind(this), 1000)

    }

    // this is moved to post wall base to wait to see if this is a valid QR code

/*
    alertView("👍", "Got it!  Now, take a photo or video, or upload from your gallery.")
    // how to pass this barcoder result along ... to camera screen i guess
    this.props.changeIndex({indexChange : 0, 'barcoderOutput' : barcoder})
*/
    // not sure if this is needed for QR use, this may be old
    /*
    if (barcoder && this.props.getSearchTag) {
      this.expectingTags = true
      this.props.getSearchTag({ search: barcoder, filter: "CODE_LOOKUP", limit: 100 })
    }
    else console.log("getSearchTag not passed in as props into PostWallV2Screen")
    */

  }
} // PostWallV2Screen


const mapStateToProps = state => {

  return {
    newPost : state.posts.newPost,
    unreadMessages : state.message.unreadMessages,
    updatePostSuccess: state.posts.updatePostSuccess,
    updatePostProgress: state.posts.updatePostProgress,
    updatePost: state.posts.updatePost,
    deletePost: state.posts.deletePost,
    auth: state.auth,
    exchangeRates: state.user.exchangeRates,
    posts: state.posts,
    postdetails: state.postdetails,
    postCreation: state.postCreation,
    order: state.order,
    love: state.love,
    options: state.postCreation.basePostWallOptions,
    nav: state.nav,
    user: state.user.otherUser,
    currentUser: state.user,
    shoppableCheckout: state.shoppable ? state.shoppable.checkout : false,
    coupon: state.coupon,
    transparentPanels: state.user.user && state.auth.user.UserId == state.user.userId && state.user.user.ApplicationOptions & 1 == 1,
    swiperIndex: state.swiper.indexChange,
    kargoeTags: state.kargoeTag,
    musicSettings: state.swiper.music,
		muted: state.swiper.music.muted,
    comments: {
			PostId:   state.posts.commentsPostId,
			comments: state.posts.comments,
			updated:  state.posts.commentsUpdated,
			loading:  state.posts.commentsLoading,
		},
		slowNetwork:  state.auth.user && (state.auth.user.ApplicationOptions & 2) == 2,
		group: state.auth.group ? state.auth.group : null,
		deepLinkTask: state.auth.deepLinkTask ? state.auth.deepLinkTask : null
  }
}
//unreadMessages
const mapDispatchToProps = dispatch => ({
  sendOneFrame: (frameFileURL, finalVideoURL, thumbURL, tileURL) => dispatch(PostsActions.sendOneFrame(frameFileURL, finalVideoURL, thumbURL, tileURL)), // for create web video post
  showPayPal: isShow => dispatch(ActionSheetActions.paypalPopup(isShow)),
  getUnreadMessage: () => dispatch(MessagesActions.getUnreadMessagesRequest()),
  showStatusPayPal: status => dispatch(PaypalActions.paypalStatusRequest(status)),
  deletePostAction: data => dispatch(PostsActions.deletePostRequest(data)),
  reportPost: data => dispatch(PostsActions.reportPostRequest(data)),
  readPost: (post) => dispatch(PostsActions.readPostRequest(post)),
  readPosts: options => dispatch(PostDetailsActions.posts2Request(options)),
  repost: (postId, post) => dispatch(CreatePostActions.createRepost(postId, post)),
  quickLove: (postId, relationship) => dispatch(LoveActions.loveInsist({ postId : postId, relationship : relationship })),
  lovePost: postId => dispatch(LoveActions.loveRequest(postId)),
  unlovePost: postId => dispatch(LoveActions.unloveRequest(postId)),
  tagDetails: (postId) => dispatch(OrderActions.orderTags(postId)),
  orderPreflight: (postId, itemId) => dispatch(OrderActions.orderPreflight(postId, itemId)),
  changeIndex: (index) => dispatch(SwiperActions.changeIndex(index)),
  setCameraLockout: (setting) => dispatch(SwiperActions.setCameraLockout(setting)),
  readUser: UserId => dispatch(UserActions.readOtherRequest(UserId)),
  readSelf: UserId => dispatch(UserActions.readRequest(UserId)),
  createStandardPostProgress: (value) => dispatch(PostsActions.createStandardPostProgress(value)),
  getOffer: offerId => dispatch(CouponActions.getOffer(offerId, null)),
  getVendor: vendorId => dispatch(CouponActions.getVendor(vendorId)),
  searchItems: data => dispatch(KargoeTagActions.kargoeSearchItemsRequest(data)),
  followUser: (userId, user2Id) => dispatch(FollowActions.followRequest(userId, user2Id)),
  unFollowUser: (userId, user2Id) => dispatch(FollowActions.unfollowRequest(userId, user2Id)),
	postComment: (params) => dispatch(PostsActions.postCommentRequest(params)),
	getPostComments: params => dispatch(PostsActions.getPostCommentsRequest(params)),
	
	// getGroup: () => dispatch(AuthActions.getGroupRequest()),
	getGroup: () => {
		dispatch(AuthActions.getGroupRequest())
		// dispatch(AuthActions.groupAddUserRequest('vAcFeeasaigZE7')) // ziggy2020
	},
	switchToGroupUser: (userId, switchPostHints) => {
		dispatch(AuthActions.groupSwitchUserRequest(userId, switchPostHints))
	},
	addGroupUser: (userId) => {
		dispatch(AuthActions.groupAddUserRequest(userId))
	},
	removeGroupUser: (userId) => {
		dispatch(AuthActions.groupRemoveUserRequest(userId))
	},
	addProfile: (screen) => {
		dispatch(AuthActions.addProfileRequest(screen))
	},
  setForceRefreshIndex: (setting) => dispatch(SwiperActions.setForceRefreshIndex(setting)),
})

export default connect(mapStateToProps, mapDispatchToProps)(PostWallV2Screen)
